// extracted by mini-css-extract-plugin
export default {"title-container__container":"TitleContainer_title-container__container__lrhAF"};